import styled from 'styled-components';

export const BookingWhatSection = styled.section`
  margin-top: 40px;
  margin-bottom: 30px;
  
  @media (min-width: 768px) {
    grid-column: 1;
    margin-bottom: 0;
  }
`;

export const BookingWhatHeading = styled.h2`
  margin: 0;
  margin-bottom: 20px;
  padding: 0;
  
  font-size: 18px;
  line-height: 1;
  
  @media (min-width: 768px) {
    font-size: 24px;
  }
  
  @media (min-width: 1024px) {
    margin-bottom: 40px;
  }
`;

export const BookingWhatDescription = styled.div`
  margin: 0;
  padding: 0;
  
  font-family: inherit !important;
  font-size: 12px;
  line-height: 16px;
  color: inherit !important;
  
  li {
    position: relative;
    
    padding-left: 18px;
    
    &:not(:last-child) {
      margin-bottom: 5px;
    }
    
    &::before {
      content: "";
      
      position: absolute;
      top: 5px;
      left: 0;
      
      width: 6px;
      height: 6px;
      
      border-radius: 50%;
      background-color: #a8a8a8;
    }
  }
  
  * {
    font-family: inherit !important;
    font-size: 12px !important;
    line-height: 16px !important;
    color: inherit !important;
    
    &:empty {
      display: none;
    }
  }
  
  @media (min-width: 768px) {
    font-size: 16px;
    line-height: 18px;
  
    * {
      font-size: 16px !important;
      line-height: 18px !important;
    }
  }
`;
